module.exports = __webpack_public_path__ + "01c7dab71b84c777abb92eea4187a7a4.jpg";